import React, { Component, lazy, Suspense } from 'react'
import { strVal } from '../../../../modules/Utils'
import { Card, Modal, Row } from 'antd'
import AccountDetails from './Details'
import { compose, withState } from 'recompose'
import IconText from '../../../../elements/IconText'
import CenterSpin from '../../../../elements/CenterSpin'

const AccountChartAsync = lazy(() => import('./Chart'), 'child')

class AccountView extends Component {
  render () {
    const { account, style, visible, setVisible, onShowTransaction } = this.props
    return (
      <Card
        title={
          <a onClick={() => setVisible(true)} className={style.accountDetailsValue}>
            <IconText
              type={'arrows-alt'}
              position={'left'}
              text={`${strVal(account, 'bank.title')} - ${strVal(account, 'bank.bank.accountNumber')}`}
            />
          </a>
        }
        className={style.accountCard}>
        <Modal
          width={1200}
          visible={visible}
          title={strVal(account, 'bank.title')}
          onCancel={() => setVisible(false)}
          footer={[]}>
          <AccountChartAsync width={1111} height={700} data={account.accountTransactions} {...this.props} />
        </Modal>
        <AccountDetails {...this.props} />
        {account.accountTransactions.length > 0 && (
          <Suspense fallback={<CenterSpin/>}>
            <Row style={{ marginTop: 100 }}>
              <AccountChartAsync data={account.accountTransactions} width={500} height={300} {...this.props} />
            </Row>
          </Suspense>
        )}
      </Card>
    )
  }
}

AccountView.propTypes = {}
AccountView.defaultProps = {}

export default compose(withState('visible', 'setVisible', false))(AccountView)
